import {map} from './index.js'; // used by map.getLayerByTitle()
import {changePage} from './changePage.js';
import zoomToVectorExtents from './zoomToVectorExtents.js';
import otherMapView from './otherMapView.js';

/**
 *  @param {string} accountNo
 *  call with a falsey accountno to clear the prop detail
 */
function detailTab(accountNo) {
  if (accountNo) {
    fetch('tabDetail.php?v=2&accountno=' + accountNo)
      .then(response => response.text())
      .then(text => {
        // is the paged mobile interface or the tabbed desktop interface active?
        if (rwg.layout.get() === 'paged') {
          changePage('detailpage')
          document.getElementById('detailpage-content').innerHTML = text
        } else { // manage tabs
          // button top-detail style is initially display=none so remove it in
          document.querySelector(`button[rwg-tab='top-detail']`).style.removeProperty('display')
          rwg.tabs.activate('top-detail')
          document.querySelector('#propdetail').innerHTML = text
        }
      })
  } else {  // called with a falsey accountno so clear the prop detail
    let el = document.querySelector('#propdetail');
    if (el) el.innerHTML = '';
  }
}

function renderInfoContent(data, zoom2it, coordsDiv, firstRun) {
  const content = document.createElement('div')
  const infotoolDiv = document.getElementById('infotool')

  // content.append('<b>' + data.numRows + ' Record(s) Found</b>');
  map.getLayerByTitle('lyrVector').getSource().clear();
  // loop thru the unique info layers
  // a single layer can return multiple records
  data.info.forEach(function(item) {
    // Check to see if we have a function registered to display records of this info type.
    let layerInfo = null;
    let infoLayerName = item.handler; // data.info[i].handler;
    let infoLayer = rwg.layers.getLayerByName(infoLayerName);
    if (infoLayer && typeof(infoLayer.info) === 'function') {  // standard server-side handler
      layerInfo = infoLayer.info(item.records /* data.info[i].records */ );
    // } else if (infoLayer && typeof(infoLayer.infov) === 'function') {  // infov() local client-side info handler
    //   layerInfo = infoLayer.infov(data.info[i].feature);
    } else if (rwg.infoLayers && typeof rwg.infoLayers[infoLayerName] === 'function') {  // look for function in rwg.infoLayers
      layerInfo = rwg.infoLayers[infoLayerName](item.records /* data.info[i].records */ );
    }
    if (layerInfo) {
      content.appendChild(layerInfo);
    }
  });

  if (coordsDiv) {
    content.appendChild(coordsDiv);
  }

  while(infotoolDiv.firstChild){
    infotoolDiv.removeChild(infotoolDiv.firstChild);
  }
  infotoolDiv.appendChild(content);

  if (rwg.layout.get() === 'paged') {  // paged mobile mode
    if (!firstRun) {  // don't switch to infopage if we're still initializing and processing a filter set in the url
      if (zoom2it) {  // renderInfoContent() called from a search result record
        changePage('mappage');
      } else {  // renderInfoContent() called from an infotool click
        changePage('infopage');
      }
    }
  } else {  // Desktop mode, has tabs

    /* Begin desktop header *** */

    const header = document.createElement("div")
    header.id = 'infoHeader'
    header.className = 'noprint'

    if (rwg.selection.tabDelimit().length) {
      const copyButton = document.createElement('button')
      copyButton.id = "copy-button"
      copyButton.innerText = "Copy to Clipboard"
      copyButton.title = "Info formatted for pasting into spreadsheet"
      copyButton.type = "button"
      header.append(copyButton)
    }
    if (rwgInitParams.otherMaps) {
      // start with a select object
      const otherMapsSelector = document.createElement('select');
      otherMapsSelector.id='othermaps'
      otherMapsSelector.name='othermaps'

      const option0 = document.createElement('option')
      option0.text = 'Different map view'
      otherMapsSelector.append(option0)

      for (const key in rwgInitParams.otherMaps) {
        if (rwgInitParams.otherMaps[key].active == true) {
          const option = document.createElement('option');
          option.value = key
          option.text = key
          otherMapsSelector.append(option)
        }
      }

      otherMapsSelector.addEventListener('change', evt => {otherMapView(evt.target.value)})
      header.append(otherMapsSelector)
    }
    infotoolDiv.prepend(header);

    /* *** End desktop header */

    rwg.tabs.activate('top-map')
    rwg.tabs.activate('side-info')
  } // Desktop

  if (zoom2it) {
    zoomToVectorExtents();
  }

}


/** renderInfo(url)
 *  @param {string} url
 *  Renders the returned attribute data for display in the info tool.
 *  (Rendering consists of putting the JSON returned by url into HTML elements)
 *  Returns a <div> containing HTML formatted data from all rows in all tables (layers).
 *  An info tool click may retrieve data from multiple tables and a table may return multiple rows.
 *  renderInfo() iterates thru the tables. The table's handler must iterate thru the rows.
 */
function renderInfo(url, zoom2it, firstRun) {
  if (typeof url === 'string') {
    fetch(url)
      .then(response => response.json())
      .then(json => success(json))
  } else {
    console.error('Error in renderInfo(): url is not a string ')
  }

  // private function, fetch callback
  function success(response) {
    const coordsDiv = document.createElement('div');

    // private function: decimal degrees to degrees, decimal minutes for Sweetwater County
    function dd2dm(val) {
      var frac = val % 1;     // fractional part
      var deg = val - frac;   // integer part
      var min = frac * 60;    // decimal minutes
      return  deg + "°" + min.toFixed(3) + "'";  // eslint-disable-line quotes
    }

    // private function (the default display format)
    function dd2fixed(val) {
      return val.toFixed(5) + '°';
    }

    // find the point in the URL, which will be in the data coordinate system, comma separated X,Y
    if (url.indexOf('&p=') > 0 ) { // if they dragged a box then there won't be a 'p=' in the url
      const p = url.substring(url.indexOf('&p=') + 3).split(',').map(parseFloat);
      const p_ll = rwg.proj.transform(rwg.proj.dataSRID, 'EPSG:4326', p)
      const formatDegrees = rwg.config.demimalMinutes ? dd2dm : dd2fixed;
      const par = document.createElement('p');
      let coords = `<div style="font-size: small;"><span style="color: grey;">Lat / Lon</span> N:&nbsp;${formatDegrees(p_ll[1])}, W:&nbsp;${formatDegrees(Math.abs(p_ll[0]))}</div>`;

      if (rwg.proj.utmSRID) {
        const p_utm = rwg.proj.transform(rwg.proj.dataSRID, rwg.proj.utmSRID, p)
        coords += `<div style="font-size: small;"><span style="color: grey;">${rwg.proj.utmTitle}</span> X:&nbsp;${Math.round(p_utm[0])}, Y:&nbsp;${Math.round(p_utm[1])}</div>`;
      }

      if (rwg.proj.spSRID) {
        const p_sp = rwg.proj.transform(rwg.proj.dataSRID, rwg.proj.spSRID, p)
        coords += `<div style="font-size: small;"><span style="color: grey;">${rwg.proj.spTitle}</span> N:&nbsp;${Math.round(p_sp[1])},&nbsp;E:&nbsp;${Math.round(p_sp[0])}</div>`;
      }

      par.innerHTML = coords;
      coordsDiv.appendChild(par);
    }

    renderInfoContent(response, zoom2it, coordsDiv, firstRun);
  }
}

export {detailTab, renderInfoContent, renderInfo};
